import styled from "styled-components"

export const Section = styled.section`
  min-height: 100vh;
`
